import {
    useImperativeHandle,
    forwardRef,
    useState,
    useRef,
    useMemo,
  } from 'react'
import PrimeModal from '@/components/primeModal'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { Tabs, Flex } from 'antd'
import type { TabsProps } from 'antd';
import PrimeTable from '@/components/primeTable'
import styles from '../index.module.less'

type Record = {
  conceptId,
  conceptCode,
  conceptName,
  conceptClassName,
  standardConcept,
  domainName,
  mappingResultVOList?: any[],
}

const OmopMappingResModal = (props, ref: any) => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Record>({})
  const [searchParams] = useSearchParams()
  const meddraFormRef = useRef<any>(null);

  const open = (data: Record) => {
    setVisible(true)
    setData(data)
  }

  const close = () => {
    setVisible(false)
  }

  const onCancel = ()=>{
    close();
  }

  useImperativeHandle(ref, () => ({
    open,
    close,
  }))

  const columnsSummary = [
    {
      title: '概念code',
      key: 'conceptCode',
    },
    {
      title: '名称',
      key: 'conceptName',
    },
    {
      title: '类别',
      key: 'conceptClassName',
    },
    {
      title: '概念类型',
      key: 'standardConcept',
    },
    {
      title: '概念域',
      key: 'domainName',
    },
    {
      title: 'ID',
      key: 'conceptId',
    }
  ]
  const columns = [
    {
        title: '映射类型',
        dataIndex: 'relationshipId',
        key: 'relationshipId',
    },
    {
        title: '目标字典',
        dataIndex: 'mappingDictName',
        key: 'mappingDictName',
    },
    {
        title: '目标code',
        dataIndex: 'mappingItemCode',
        key: 'mappingItemCode',
    },
    {
        title: '目标词',
        dataIndex: 'mappingItemName',
        key: 'mappingItemName',
    },
    {
        title: 'ID',
        dataIndex: 'mappingConceptId2',
        key: 'mappingConceptId2',
    }
  ]

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: '映射结果',
      children: (
        <>
         {/* <PrimeTable bordered dataSource={data?.mappingResultVOList || []} columns={columnsSummary} pagination={false} /> */}
         <Flex className={styles.summary_container}>
          {columnsSummary.map(({ title, key }) => ( <div className={styles.section} key={key}>
            <div className={styles.title}>{title}</div>
            <div className={styles.desc}>{data[key]}</div>
          </div> ))}
         </Flex>
         <PrimeTable dataSource={data?.mappingResultVOList || []} columns={columns} pagination={false} />
        </>
      ),
    },
    // TODO: 暂时隐藏,产品待确认
    // {
    //   key: '2',
    //   label: '映射层级',
    //   children: '',
    // },
  ];

  return (
    <PrimeModal
      title={t('查看')}
      open={visible}
      onCancel={onCancel}
      width={840}
      footer={null}
      className={styles.omop_mapping_modal}
    >
      <Tabs defaultActiveKey="1" items={items} />
    </PrimeModal>
  )
}
  
export default forwardRef(OmopMappingResModal)
  